import { screenMdMin, screenSmMax } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
export const ShowOnHoverClassName = 'show-on-hover';
const Wrapper = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;

  @media (min-width: ${screenMdMin}) {
    // hover functionality only when hover supported
    @media (hover: hover) {
      :hover .mask {
        height: 100%;
      }
    }
  }
`;
const Mask = styled.div `
  position: absolute;
  width: 100%;
  height: 0px;
  color: ${({ maskTextColor }) => maskTextColor} !important;
  fill: ${({ maskTextColor }) => maskTextColor} !important;
  background: ${({ maskColor }) => maskColor};
  transition: height 400ms;
  transition-timing-function: cubic-bezier(0.33, 0, 0.2, 1);
  overflow-y: hidden;
  // adjust mask for the 1px top line
  @media (min-width: ${screenMdMin}) {
    padding-top: 1px;
  }
`;
const Under = styled.div `
  /* background: transparent; */
  width: 100%;
  height: 100%;
  color: ${({ textColor }) => textColor};
  fill: ${({ textColor }) => textColor};

  .show-on-hover {
    color: black !important;
    fill: black !important;
    mix-blend-mode: screen !important;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  @media (max-width: ${screenSmMax}) {
    border-radius: 6px;
    color: ${({ maskTextColor }) => maskTextColor};
    fill: ${({ maskTextColor }) => maskTextColor};
    background-color: ${({ maskColor }) => maskColor};
    /* .show-on-hover {
      opacity: 1 !important;
    } */
  }

  @media (min-width: ${screenMdMin}) {
    // always show top border
    border-top: 1px solid ${({ maskColor }) => maskColor};
    // hover functionality only when hover supported
    @media (hover: hover) {
      // hide show on hover content in background
      .show-on-hover {
        color: ${({ backgroundColor }) => backgroundColor};
        fill: ${({ backgroundColor }) => backgroundColor};
      }
    }
  }
`;
export const MaskAnimation = ({ children, maskColor, maskTextColor, backgroundColor, textColor, }) => {
    return (React.createElement(Wrapper, { maskColor: maskColor, maskTextColor: maskTextColor, backgroundColor: backgroundColor, textColor: textColor },
        React.createElement(Under, { className: "under", maskColor: maskColor, maskTextColor: maskTextColor, backgroundColor: backgroundColor, textColor: textColor }, children),
        React.createElement(Mask, { className: "mask", maskColor: maskColor, maskTextColor: maskTextColor, backgroundColor: backgroundColor, textColor: textColor }, children)));
};
